// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"62":"brand-rigging","155":"brand-danfloss"}[chunkId] + "." + {"62":"f15d32a0","155":"33549909"}[chunkId] + ".chunk.css";
};